import React from 'react';
import { useTranslation } from 'react-i18next';

import { Card, Icon } from '@weezevent/nacre';

import { InfoTextTooltip } from '../../../../attendee/detail/components/infotext-tooltip/infoTextTooltip';

import css from './components.module.css';

const SelectedCondition = ({ condition, handleEdit, handleDelete }) => {
    const { t } = useTranslation();

    return (
        <Card className={css['selected-action-card']}>
            <InfoTextTooltip
                title={condition.name}
                subtitle={
                    <span>
                        {`${t('ticket.common.type')}: `}
                        {t(`ticket.moderation.statusesTransitions.transitionConditionsList.conditionTypes.${condition.type}`)}
                    </span>
                }
            />
            <div>
                {handleEdit && <Icon className={css['selected-action-status-btn']} name="eye" onClick={() => handleEdit(condition)} />}
                {handleDelete && <Icon className={css['selected-action-status-btn']} name="cross" onClick={() => handleDelete(condition)} />}
            </div>
        </Card>
    );
};

export default SelectedCondition;
